import React from "react";

const TournamentIcon = (props: any) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.0944 16.0588V15.4604C13.7065 15.4604 15.0496 14.3658 16.0865 12.2065C16.7999 10.7202 17.1772 9.01791 17.1772 7.28462V3.23809H11.3721V2.63965H17.7874V7.28462C17.7874 9.10604 17.3902 10.8959 16.6385 12.4616C15.5084 14.8151 13.9373 16.0588 12.0944 16.0588Z"
        fill="currentColor"
      />
      <path
        d="M12.4571 21.057H11.8469V16.047C10.1354 15.9164 8.67474 14.6836 7.60792 12.4613C6.8562 10.8955 6.45898 9.10511 6.45898 7.28422V2.93848H7.06923V7.28422C7.06923 9.01752 7.44647 10.7198 8.15991 12.2061C9.19622 14.3654 10.5393 15.46 12.152 15.46H12.4571V21.057Z"
        fill="currentColor"
      />
      <path
        d="M6.06302 12.9872C5.13822 12.9872 4.31439 12.2593 3.61427 10.823C3.0118 9.58696 2.69336 8.16159 2.69336 6.70086V4.33594H6.7648V4.93438H3.30361V6.70031C3.30361 8.07237 3.60151 9.40852 4.16516 10.5646C4.57069 11.3964 5.22921 12.3882 6.06302 12.3882V12.9866V12.9872Z"
        fill="currentColor"
      />
      <path
        d="M17.9381 12.9866V12.3882C18.7719 12.3882 19.4304 11.3964 19.836 10.5646C20.3996 9.40852 20.6975 8.07237 20.6975 6.70031V4.93438H17.2363V4.33594H21.3078V6.70031C21.3078 8.16105 20.9893 9.58642 20.3869 10.8225C19.6867 12.2587 18.8629 12.9866 17.9381 12.9866Z"
        fill="currentColor"
      />
      <path
        d="M14.3665 20.7568H9.93945V21.3553H14.3665V20.7568Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default TournamentIcon;
